import { render, staticRenderFns } from "./SntCustomerTag.vue?vue&type=template&id=75d94cb4&"
import script from "./SntCustomerTag.vue?vue&type=script&lang=js&"
export * from "./SntCustomerTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports